export const _userPilotTracking = (eventName = '', meta = {}) => {
  if (window?.userpilot) {
    window?.userpilot.track(eventName, meta)
    window.console.info('UserPilot: ', eventName, meta)
  }
}
